module.exports = __webpack_public_path__ + "img/iphone-map-GERMANY-en.acc3c550.png";